import React, { useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router";
import { useSearchParams } from "react-router-dom";
import { decode as base64_decode } from "base-64";
import { jwtDecode } from "jwt-decode";

//Context
import { AuthContext } from "../context/AuthContext";

//Utils
import { authTypes } from "../types/authTypes";

const PrivateRouter = ({ children }) => {
  const location = useLocation();

  const { dispatch } = useContext(AuthContext);

  const { log } = useContext(AuthContext);

  const [searchParams] = useSearchParams();

  const data = searchParams.get("data");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has("data")) {
      dispatch({ type: authTypes.login });

      if (data) {
        let decoded = base64_decode(data)?.split("/");

        if (decoded?.length > 0) {
          const jwtDecoded = jwtDecode(decoded[1]);

          //Datos de logueo en localstorage basicos
          localStorage.setItem("token", decoded?.[1]);
          localStorage.setItem("userId", jwtDecoded?.userId);
          localStorage.setItem("temp_doc", jwtDecoded?.document);
          localStorage.setItem(
            "creator_document",
            JSON.stringify(jwtDecoded?.document)
          );
          localStorage.setItem("is_from_whatsapp", true);
          localStorage.setItem("whatsapp_session_id", decoded?.[3]);

          //Datos de credito nuevo en localstorage
          localStorage.setItem("error_list", JSON.stringify([]));
          localStorage.setItem("processType", decoded?.[4]);
          localStorage.setItem("latestStep", "complement-data");
          localStorage.setItem("isCreditInProcess", true);
          localStorage.setItem("form_id", decoded?.[2]);
          localStorage.setItem("insurance_id", decoded?.[5]);
        }
      }
    }
  }, [location.search, dispatch]);

  return log.log ? children : <Navigate to="/login" />;
};

export default PrivateRouter;
